import AboutInfo from "./about-info";
import "./about.css"
import Footer from "./footer";
import Nav from "./navigation/nav";

function About(){
    return(
        <>
        <Nav></Nav>
        <AboutInfo></AboutInfo>
        <Footer></Footer>
        </>
    )
}
export default About;